import axios from 'axios';
import { history } from '../store';

export const TEAM_SWITCHED = 'TEAM_SWITCHED';

const switchTeams = teamId => (
    (dispatch) => {
        return axios.post('/api/teams/switch', {
            team_id: teamId,
        })
            .then((response) => {
                dispatch({
                    type: TEAM_SWITCHED,
                    teamId,
                });

                // Reload on change team for now
                window.location.reload();

                return response;
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    window.location = '/login';
                }
            });
    }
);

export default switchTeams;
